export const Swatches = ({ colors, size = "md", testId, ring = "var(--pp-cream-card)" }) => {
  const dim = size === "sm" ? "h-4 w-4" : "h-6 w-6";
  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      {colors.map((c) => (
        <span
          key={c}
          className={`${dim} rounded-full`}
          style={{ backgroundColor: c, boxShadow: `0 0 0 1px ${ring}` }}
          title={c}
        />
      ))}
    </div>
  );
};
